module.exports = __webpack_public_path__ + "img/arka-plan.524d031b.png";